import { images } from "../constants";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Secura",
    headingPart1: "Protect",
    spanText: "Your Property",
    headingPart2: "with CCTV",
    description: "Implement top-tier CCTV surveillance to ensure complete security, protection, and peace of mind.",
    buttonText: "Learn More",
    buttonLink: "About-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Secura",
    headingPart1: "Monitor",
    spanText: "24/7 Security",
    headingPart2: "with Ease",
    description: "Stay connected and monitor your property round the clock with our reliable solutions for ultimate security.",
    buttonText: "Learn More",
    buttonLink: "About-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Secura",
    headingPart1: "Upgrade",
    spanText: "Security",
    headingPart2: "with Advanced Systems",
    description: "Enhance your security infrastructure with state-of-the-art surveillance systems for complete protection.",
    buttonText: "Learn More",
    buttonLink: "About-us",
  },
];

export default home;